

























































































import Vue from 'vue'
import moment from 'moment'
import User from '@/provider/user'
import { GChart } from 'vue-google-charts'
import Component from 'vue-class-component'
import { UserInfoProvider, ManagerUserInfoProvider } from '@/provider/userInfo'
import { UserInfo } from '@/provider/interface'
import { AuthDynamoDB } from '../provider/dynamodb'
import AWSConfig from '@/assets/aws-exports'
import CircularLoading from '@/components/Loading/CircularLoading.vue'
import { Setting } from '@/setting'

@Component({
  components: {
    GChart,
    CircularLoading
  }
})
export default class SelfCheck extends Vue {
  loading: boolean = true
  username: string = ''
  userProvider!: User
  userData: any = null
  provider: UserInfoProvider = new ManagerUserInfoProvider(
    new AuthDynamoDB(),
    AWSConfig.userInfoTable,
    this.$store.getters.currentDivision.id
  )
  chartData = [
    ['週', '得点'],
    ['', 0]
  ]
  userInfo?: UserInfo
  encourageMailStatus: Array<boolean> = Array(Setting.SELFCHECK_LAST_INDEX + 1).fill(false)
  adminComment: string = ''

  chartOptions = {
    title: 'PHQ9',
    vAxis: {
      maxValue: 27,
      minValue: 0,
      viewWindow: {
        max: 27,
        min: 0
      }
    },
    hAxis: {
      maxValue: 52,
      viewWindow: {
        max: 20
      }
    }
  }

  async mounted () {
    console.log('SelfCheck - mounted. username:', this.$route.params.username)
    console.log('SelfCheck - mounted. userId:', this.$route.params.userId)
    this.userInfo = (await this.provider.loadByUsername(this.$route.params.username)).data[0]
    if (this.userInfo.encourageMailStatus !== undefined) {
      this.encourageMailStatus = this.userInfo.encourageMailStatus
    }
    if (this.userInfo.adminComment !== undefined) {
      this.adminComment = this.userInfo.adminComment
    }
    this.userProvider = new User(this.$route.params.userId)
    this.userData = await this.userProvider.getSelfCheck()
    console.log('SelfCheck - userData:', this.userData)

    for (const selfCheck of this.userData) {
      this.chartData.push([
        `${Setting.SelfCheckIndexToWeek(selfCheck.answerIndex)}`,
        selfCheck.PHQ9Point
      ])

      if (!selfCheck.answers || !selfCheck.answers.PHQ9) {
        continue
      }

      selfCheck.answers.PHQ9.sort((a: any, b: any) => {
        const anum = parseInt(a.itemId.substring('PHQ9_'.length))
        const bnum = parseInt(b.itemId.substring('PHQ9_'.length))
        return anum - bnum
      })
    }

    const preSurvey = await this.userProvider.getPreSurvey()
    const extraSurvey = (Setting.SELFCHECK_EXTRA_SURVEY as { [survey: string]: number[]})
    Object.keys(extraSurvey).forEach(survey => {
      const weeks = extraSurvey[survey]
      if (weeks.find(v => v === 0) !== undefined) {
        const week0SelfCheck = this.userData.find((v: any) => v.answerIndex === 0)
        week0SelfCheck[`${survey}Point`] = preSurvey[`${survey}Point`]
      }
    })

    this.chartData.splice(1, 1)
    this.loading = false
  }

  getWeek (answerIndex: number): number {
    return Setting.SelfCheckIndexToWeek(answerIndex)
  }

  hasExtraSurvey (selfcheck: any, survey: string) {
    const extraSurvey = (Setting.SELFCHECK_EXTRA_SURVEY as { [survey: string]: number[]})
    const weeks = extraSurvey[survey]
    if (weeks && !weeks.some(v => v === selfcheck.answerIndex)) {
      return false
    }
    return true
  }

  getClass (selfcheck: any, survey: string) {
    if (survey) {
      if (this.hasExtraSurvey(selfcheck, survey) === false) {
        return 'not-exists'
      }
    }

    const today = new Date()
    let classStrings = ''
    if (selfcheck === undefined) {
      classStrings += 'not-exists'
      return classStrings
    }
    if (new Date(selfcheck.canAnswerAt) > today) {
      classStrings += 'not-opened'
      return classStrings
    }
    if (selfcheck.answeredAt) {
      classStrings += 'answered'
      return classStrings
    }

    const duration = Setting.SELFCHECK_DEADLINE_DAYS[selfcheck.answerIndex]
    const canAnswerAt = new Date(selfcheck.canAnswerAt)
    const diff = moment.duration(moment(today).diff(moment(canAnswerAt)))
    if (diff.asDays() < duration) {
      classStrings += 'not-answered'
      return classStrings
    } else {
      classStrings += 'deadline-overed'
      return classStrings
    }
  }

  isPHQ9Alert (selfCheck: any, index: number): boolean {
    if (index !== Setting.SELFCHECK_PHQ9_ALERT_ANSWER_INDEX) {
      return false
    }

    if (!selfCheck.answers || !selfCheck.answers.PHQ9) {
      return false
    }

    const PHQ9: { itemId:string, answer:any }[] = selfCheck.answers.PHQ9
    const item = PHQ9.find(e => e.itemId === Setting.SELFCHECK_PHQ9_ALERT_ANSWER_ID)
    return item !== undefined && item.answer >= Setting.SELFCHECK_PHQ9_ALERT_POINT
  }

  getPHQ9Point (selfCheck: any, index: number): string {
    if (!selfCheck.answers || !selfCheck.answers.PHQ9) {
      return ''
    }

    const PHQ9: { itemId:string, answer:any }[] = selfCheck.answers.PHQ9
    return `${PHQ9[index].answer}`
  }

  hasEncourageMailCheck (index: number) {
    return Setting.ENCOURAGE_MAIL_INDEXES.some(v => v === index)
  }

  getExtraSurveyPoint (selfCheck: any, survey: string): string {
    const pointKey = `${survey}Point`
    if (selfCheck[pointKey] === undefined) {
      return ''
    }
    return `${selfCheck[pointKey]}`
  }

  async onEncourageMailStatusChange () {
    if (!this.userInfo) {
      console.log('userinfo not initialized')
      return
    }
    const key = { division: this.userInfo.division, sortDate: this.userInfo.sortDate }
    await this.provider.updateValue(key, 'encourageMailStatus', this.encourageMailStatus)
  }

  async onAdminCommentBlur () {
    if (!this.userInfo) {
      console.log('userinfo not initialized')
      return
    }
    const key = { division: this.userInfo.division, sortDate: this.userInfo.sortDate }
    await this.provider.updateValue(key, 'adminComment', this.adminComment)
  }

  get selfCheckExtraSurveys (): any[] {
    return Object.keys(Setting.SELFCHECK_EXTRA_SURVEY)
  }
}
